
import React from 'react';
import { QuizContentViewer } from './QuizContentViewer';
import { ErrorContentViewer } from './ErrorContentViewer';

interface TrainingQuizContentViewerProps {
  quiz: any;
  isLoadingQuiz: boolean;
  isAccessible: boolean;
  progress: number;
  isLastSection: boolean;
  quizId?: string;
  resourceId: string;
  quizCompleted?: boolean;
  quizAttempt?: any;
  onComplete?: () => void;
  onQuizUpdate?: (quizId: string, attempt: any) => Promise<void>;
  error?: string | null;
}

export function TrainingQuizContentViewer({
  quiz,
  isLoadingQuiz,
  isAccessible,
  progress,
  isLastSection,
  quizId,
  resourceId,
  quizCompleted,
  quizAttempt,
  onComplete,
  onQuizUpdate,
  error
}: TrainingQuizContentViewerProps) {
  // Add more detailed logging for debugging
  console.log('TrainingQuizContentViewer props:', {
    hasQuiz: !!quiz,
    isLoadingQuiz,
    isAccessible,
    resourceId,
    quizId,
    quizCompleted,
    hasQuizAttempt: !!quizAttempt,
    error
  });

  // If there's an error and no quiz data, show error view instead
  if (error && !quiz && !isLoadingQuiz) {
    return (
      <ErrorContentViewer 
        message="Quiz data not available" 
        details={error} 
        onRetry={() => window.location.reload()}
      />
    );
  }

  // If no resource ID, show error
  if (!resourceId) {
    return (
      <ErrorContentViewer 
        message="Missing resource ID" 
        details="Cannot load quiz without a resource ID" 
        onRetry={() => window.location.reload()}
      />
    );
  }

  return (
    <QuizContentViewer
      quiz={quiz}
      isLoading={isLoadingQuiz}
      isAccessible={isAccessible}
      progress={progress}
      isLastSection={isLastSection}
      quizId={quizId}
      resourceId={resourceId}
      quizCompleted={quizCompleted}
      quizAttempt={quizAttempt}
      onComplete={onComplete}
      onQuizUpdate={onQuizUpdate}
      error={error}
    />
  );
}
